// extracted by mini-css-extract-plugin
export default {"card":"styles_card__NubT7","header":"styles_header__p5oHp","title":"styles_title__Y-JDG","logo":"styles_logo__JRBsK"};